import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { VersionBanner } from "@/components/VersionBanner";

interface DashboardLayoutProps {
  children: React.ReactNode;
  title?: string;
  /** Page-level actions shown at the right end of the sticky header. */
  actions?: React.ReactNode;
}

export function DashboardLayout({ children, title, actions }: DashboardLayoutProps) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <VersionBanner />
          <header className="sticky top-0 z-20 h-14 flex items-center gap-4 border-b bg-card px-6 shrink-0">
            <SidebarTrigger />
            {title && (
              <h1 className="font-display text-xl font-semibold text-foreground">
                {title}
              </h1>
            )}
            {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
          </header>
          <main className="flex-1 overflow-auto p-6">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
